/**
 * Query key factory for Notes
 * 
 * This file provides a consistent way to define query keys for React Query
 * to properly deduplicate and invalidate related queries.
 */

/**
 * Centralized query keys for notes to ensure consistent cache management
 */
export const noteKeys = {
  // Base key for all note-related queries
  all: ['notes'] as const,
  
  // Key for lists of notes
  lists: () => [...noteKeys.all, 'list'] as const,
  
  // Key for filtered lists with parameters
  list: (filters: import('./noteTypes').NoteFilters) => [...noteKeys.lists(), filters] as const,
  
  // Key for notes by topic ID
  byTopic: (topicId: string) => [...noteKeys.lists(), { topicId }] as const,
  
  // Key for notes filtered by user ID
  byUser: (userId: string) => [...noteKeys.lists(), { userId }] as const,
  
  // Base key for note detail queries
  details: () => [...noteKeys.all, 'detail'] as const,
  
  // Key for a specific note by ID
  detail: (id: string) => [...noteKeys.details(), id] as const,
  
  // Key for storing filter settings for a specific topic
  filters: (topicId: string) => [...noteKeys.all, 'filters', topicId] as const,
};